export default {
    showAddresses:      { method: 'get',    url: 'addresses/{id}' },
    indexAddresses:     { method: 'get',    url: 'addresses' },
    storeAddress:       { method: 'post',   url: 'addresses' },
    updateAddress:      { method: 'put',    url: 'addresses/{id}' },
    destroyAddress:     { method: 'delete', url: 'addresses/{id}' },
    distancesAddress:   { method: 'get',    url: 'addresses/distances/{campus_id}' },
}